export default {
	isPqyUser: false,
	resultList: [],
	okReport: [],
	ngReport: [],
	pmcList: [],
	partCkuList: [],

	/**주의사항 */
	attentionList: [], // 주의 사항 대분류
	okList: [], //결과는 합격인데, 리스트가 다 불량인경우
	ngList: [], //결과는 불합격인데, 리스트가 다 합격인경우

	/**selectBox */
	sgrpAllList: [],
	lgrpCdList: [],
	sgrpCdList: [],
	tymaCdList: [],
	ipnWayCdList: [],
	utmCdList: [],
	icrtCdList: [],
	indvJgmtCdList: [],
	oputStCdList: [],
	ovrlJgmtCdList: [],

	searchParams: SEARCH_PARAMS(),
	partCkuInfo: PAGING_INFO(),
	pmcPagingInfo: PAGING_INFO(),
	selectedRow: SELECTED_ROW()
};

function SEARCH_PARAMS() {
	return {
		disabled: false,
		custCd: '',
		custNm: '',
		custYn: '',
		cpnyScn: '20',
		pmcNo: '',
		ipnNos: '',
		saveStatus: '' //save 임시저장, register 작성, renew 재작성, changeCust : 업체변경
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 0
	};
}

function SELECTED_ROW() {
	return {
		saveStatus: '', //save 임시저장, register 작성, renew 재작성, changeCust : 업체변경
		pmcNo: '', //pmc 번호
		ipnNos: '', //차수
		prdtDd: '', //생산일
		custCd: '', //업체코드
		custNm: '', //업체명
		cpnyScn: '', //업체분류코드 20 납품사
		custProdNo: '' /* 고객사코드 */,
		tymaCd: '', //기종코드
		tymaNm: '', //기종명
		ipnDd: '', //검사일
		pprrDt: '', //작성일 (작성하는 오늘 날짜)
		rvwDd: '', //검토일 (작성일 동일, 저장일 아님)
		csetDd: '', //승인일 (작성일 동일, 저장일 아님)
		pprrId: '', //작성자id
		rvwrId: '', //검토자id
		cserId: '', //승인자id
		pprrNm: '', //작성자명
		rvwrNm: '', //검토자명
		cserNm: '', //승인자명

		powQltyCd: '', //공정품질코드
		partBloCd: '', //부품누락체크코드
		partSrgCd: '', //부품NG체크코드
		apenCkuCd: '', //외관검사코드
		clfcStCd: '', //체결상태코드
		cdcnStCd: '', //배선상태코드

		badSbc: '', //불량내용
		jgmtRsltCd: '', //판정결과코드
		oldJgmtRsltCd: '', //판정결과코드
		jgmtRsltNm: '', //판정결과명
		oputStCd: '', //출력상태코드
		oputStNm: '', //출력상태코드
		sumNg: '', //불합격개수
		pmcNo1:''
	};
}

export { SEARCH_PARAMS, PAGING_INFO, SELECTED_ROW };
